
angular.module('bmsApp.employeeUnavailability').factory('EmployeeUnavailabilitySvc', function (CRUDSvc) {

	return {
		read: function (id) {
			return CRUDSvc.get('api/employee/unavailability/read/' + id);
		},
		save: function (params) {
			return CRUDSvc.post('api/employee/unavailability/save', params);
		}
	};

});
